import Eye from '@v4/components/common/FAIcons/Regular/Eye'
import React, { memo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import useStyles from './OnlyVisible.styled'

const OnlyVisible = ({ color = 'gray' }) => {
	const classes = useStyles()

	return (
		<div className={clsx(classes.root, classes[color])}>
			<Eye />
			<span className={classes.label}>Only visible to you</span>
		</div>
	)
}

OnlyVisible.propTypes = {
	color: PropTypes.oneOf(['dark', 'gray']),
}

export default memo(OnlyVisible)
